module.exports = __webpack_public_path__ + "img/10884_L.48d55fbe.png";